/**
 * @desc 财务画像-财务舞弊分析-造假模板
 * @author caoyx
 */
import styles from '../common.scss';
import React from 'react';
import { Table } from 'antd';
import cns from 'classnames';
import { PAGE_SIZE } from '../../../../constants/common';
import {fieldAnomaly} from '../../../../utils/formatter';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import { fraudTemplateColumn, rawTemplateColumn } from './columns';
import {avgScatterOption} from '../../common/commons';

export default function FraudTemplate({ className, data = {}, ...other }) {
    const {
        abnormalIndex,
        indexDescription,
        featureType,
        abnormalIndexDescription,
        financeFraudAbnormalDetailDto = [],
        financeFraudCurrentYearStaticsVO = {}
    } = data;
    let scatterOption = avgScatterOption(financeFraudCurrentYearStaticsVO);
    // 动态设置表头名称
    fraudTemplateColumn[1].title = fieldAnomaly(abnormalIndex);
    rawTemplateColumn[1].title = fieldAnomaly(abnormalIndex);
    let columnsTitle = featureType === 'raw' ? rawTemplateColumn : fraudTemplateColumn,
        echartTitle = featureType === 'raw' ? abnormalIndex : `${abnormalIndex}残差`;

    return (
        <div className={cns(styles.fraudTemplate, className)} {...other}>
            <div className={cns(styles.leftBox, styles.box, 'clearfix')}>
                <div className={styles.textBox}>
                    <div className={styles.title}>
                        <span className={cns(styles.leftTitle, styles.subTitle)}>异常指标：{abnormalIndex}</span>
                        {indexDescription && <span className={styles.subTitle}>回归模型：{indexDescription}</span>}
                    </div>
                    <div>{fieldAnomaly(abnormalIndexDescription)}</div>
                </div>
                <Table
                    bordered
                    rowKey="abnormalYear"
                    dataSource={financeFraudAbnormalDetailDto}
                    columns={columnsTitle}
                    pagination={financeFraudAbnormalDetailDto.length > PAGE_SIZE}
                />
            </div>
            <div className={cns(styles.rightBox, styles.box)}>
                <p className="wrap-title">{echartTitle}</p>
                <BBDLineBar option={scatterOption} />
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/FraudTemplate.jsx